import { validator } from "LIB/validate-this";
import { get } from "lodash";
import { COMPANY, COMPANY_ID, NAME } from "APP_ROOT/constants";
import * as rules from "LIB/validation/rules";
import {
  AVG_OVERHAUL,
  AVG_REPAIR,
  AVG_TEST,
  BER_RATE,
  EVALUATION_FEE,
  OVERHAUL_TAT,
  QUOTE_TYPE,
  REPAIR_QUOTE_LINE_ITEM,
  REPAIR_TAT,
  STANDARD,
  TEST_TAT
} from "MODULES/RepairQuotes/constants";
import { PART_ID } from "MODULES/inventories/constants";

export default function validate(values) {
  return validator(values, v => {
    if (values.company) {
      v.validateChild(COMPANY, company => {
        company.validate(NAME).satisfies(rules.required);
      });
    } else {
      v.validate(COMPANY_ID).satisfies(rules.required);
    }

    v.validateChild(REPAIR_QUOTE_LINE_ITEM, quote => {
      quote.validate(PART_ID, QUOTE_TYPE).satisfies(rules.required);

      if (get(values, "repair_quote_line_item.quote_type") === STANDARD) {
        quote
          .validate("Repair Quote")
          .satisfies(
            rules.requiresAtLeast(
              1,
              AVG_TEST,
              AVG_OVERHAUL,
              AVG_REPAIR,
              EVALUATION_FEE
            )
          );
      }

      quote
        .validate(BER_RATE)
        .satisfies(
          rules.isLessThanOrEqualTo(100),
          rules.isGreaterThanOrEqualTo(0)
        );

      quote
        .validate(OVERHAUL_TAT, REPAIR_TAT, TEST_TAT)
        .satisfies(
          rules.isGreaterThanOrEqualTo(1),
          rules.isLessThanOrEqualTo(999)
        );
    });
  });
}



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/RepairQuotes/Create/validate.js